import { Component, HostBinding, Inject, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { DashboardService } from '../../dashboard.service';

export interface DialogData {
  hideActionBtns?: boolean,
  templateDetails: {
    _id: string;
    templateType: string;
    content: { content: string }
    cardHeading: { title: string, previewTitle: string }
  },
  logo?: string,
  mobileNumber?: string,
  companyName?: string,
  assessmentData?: any
}

@Component({
  selector: 'app-preview-template',
  templateUrl: './preview-template.component.html',
  styleUrls: ['./preview-template.component.scss']
})

export class PreviewTemplateComponent implements OnInit {

  logo: string = '';

  constructor(
    public dialogRef: MatDialogRef<PreviewTemplateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private dashboardService: DashboardService) { }

  ngOnInit(): void {
    if (this.data.templateDetails.templateType === 'Email' || this.data.templateDetails.templateType === 'whatsapp') {
      this.getLogo();
    }
  }

  private getLogo(): void {
    this.dashboardService.getLogo().subscribe((logo) => {
      this.logo = logo?.logo
    })
  }

  editTemplate(): void {
    this.dialogRef.close('edit');
  }

  cancel(): void {
    this.dialogRef.close();
  }

}
